import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const SETTLEMENT_FORM = {
  INDIVIDUAL: 'individual',
  ASSIGNMENT: 'assignment',
} as const;

export const SETTLEMENT_FORM_NAME = 'settlement_form';

interface Props {
  name?: string;
}

export const RadioGroupDryingSettlementForm: FC<Props> = ({
  name = SETTLEMENT_FORM_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Jaka była forma rozliczenia?')}</FormLabel>
          <FormControl>
            <RadioGroup {...field} layout="horizontal">
              <RadioItem
                data-testid={`${name}-radio-group-${SETTLEMENT_FORM.INDIVIDUAL}`}
                value={SETTLEMENT_FORM.INDIVIDUAL}
                label={i18n.t('Indywidualnie')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${SETTLEMENT_FORM.ASSIGNMENT}`}
                value={SETTLEMENT_FORM.ASSIGNMENT}
                label={i18n.t('Cesja na osuszanie')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default RadioGroupDryingSettlementForm;
